import React, { useMemo } from 'react';
import { CenteredContentLayout } from '../../../../components/containers/CenteredContentLayout';
import { ThirdNavRightControls } from '../ThirdNavRightControls';
import { useThirdNavChildren } from '../../../../hooks/useThirdNavChildren';
import { SnippetsView, SnippetsViewLayoutProps } from '../Snippets.view';

export type SnippetsPageViewProps = SnippetsViewLayoutProps & {
  //
  onCreateSnippetDialogOpen: VoidFunction;
  loading: boolean;
};

export const SnippetsPageView = (props: SnippetsPageViewProps): JSX.Element => {
  const { loading, onCreateSnippetDialogOpen } = props;

  const thirdNavChildren = useMemo(
    () => ({
      right: <ThirdNavRightControls onClick={() => onCreateSnippetDialogOpen()} />,
      left: <></>
    }),
    [onCreateSnippetDialogOpen]
  );

  useThirdNavChildren(thirdNavChildren);

  return (
    <CenteredContentLayout loading={loading}>
      <SnippetsView {...props} />
    </CenteredContentLayout>
  );
};
